import { useState, useEffect } from 'react'
import {
    Box,
    Grid,
    Typography,
    Pagination,
    Skeleton,
    Card
} from '@mui/material'
import { ROOT_PATH, App_Language_key } from '../../common/config'
import { useLoading } from '../../common/hooks'
import axios from 'axios'
import { NewsUrl } from '../../common/url'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

export const SMNews: React.FC = () => {
    const { t } = useTranslation()

    const [pageIndex, updatePageIndex] = useState(1)

    const [pageCount, setPageCount] = useState(1)

    const [data, setData] = useState([])

    const { start, finish } = useLoading()

    const language = sessionStorage.getItem(App_Language_key) === 'ms' ? 'BM' : 'EN'
    
    const fetchList = async (page: number) => {
        start()
        try {
            const response = await axios.get(NewsUrl + '?pagination[page]=' + page + '&pagination[pageSize]=9&sort=sequence:ASC&publicationState=live&filters[language][$eq]=' + language)
            setData(response.data['data'])
            setPageCount(response.data['meta']['pagination']['pageCount'])
        } catch (error) {
            console.error(error)
        }
        finish()
    }

    useEffect(() => {
        ; (async () => {
            await fetchList(1)
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onChange = (event, value) => {
        updatePageIndex(value)
        fetchList(value)
    }

    const detail = (id: number) => {
        window.location.href = (ROOT_PATH + '/news-detail?id=' + id)
    }

    const skeletonData = [
        '',
        '',
        '',
        '',
        '',
        ''
    ]

    const skeletonItem = (index: number) => {
        return (
            <Grid item key={index} xs={4}>
                <Box>
                    <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'100%'} height={'260px'} style={{ borderRadius: '4px' }} ></Skeleton>
                    <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'80%'} height={'22px'} style={{ marginTop: '26px', borderRadius: '4px' }}></Skeleton>
                    <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'60%'} height={'16px'} style={{ marginTop: '16px', borderRadius: '4px' }}></Skeleton>
                    <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'40%'} height={'16px'} style={{ marginTop: '16px', borderRadius: '4px' }}></Skeleton>
                </Box>
            </Grid>
        )
    }

    // ======================= VIEWS
    return (
        <Box sx={{
            width: '100%',
            paddingLeft: isTablet ? '20px': '60px',
            paddingRight: isTablet ? '20px': '60px',
            paddingTop: '30px',
            paddingBottom: '40px',
            display: 'flex',
            flexDirection: 'column'
        }}>
            {
                data === null || data.length === 0 ?
                    <Box>
                        <Grid container columnSpacing={2} rowSpacing={6}>
                            {skeletonData.map((item, index) => (
                                skeletonItem(index)
                            ))}
                        </Grid>
                    </Box>
                    :
                    <Box>
                        <Box sx={{ width: '100%' }}>
                            <Grid
                                container
                                columnSpacing={2}
                                rowSpacing={8}
                            >
                                {data.map((item, index) => (
                                    <Grid item key={index} xs={4}>
                                        <Box
                                            onClick={() => detail(data[index]['id'])}
                                            sx={{
                                                width: '100%',
                                                height: '100%',
                                                borderRadius: 6,
                                                cursor: 'pointer',
                                                paddingLeft: '12px',
                                                paddingRight: '12px',
                                            }}>
                                            <Card
                                                style={{
                                                    borderRadius: '4px',
                                                    boxShadow: 'none',
                                                    border: 'none',
                                                    '&:hover': {
                                                        boxShadow: 'none'
                                                    }
                                                }}>
                                                <div dangerouslySetInnerHTML={{ __html: data[index]['attributes']['image'] }} style={{ minHeight: isTablet ? '140px' : '200px', borderRadius: '4px' }} />
                                            </Card>
                                            <Typography fontWeight={400} fontSize={'16px'} color={'#6B6B6B'} sx={{
                                                paddingTop: isTablet ? '12px' : '35px'
                                            }}>
                                                {data[index]['attributes']['Description']}
                                            </Typography>
                                            <Typography fontWeight={700} fontSize={'20px'} color={'#141F39'} sx={{
                                                paddingTop: '6px'
                                            }}>
                                                {data[index]['attributes']['title']}
                                            </Typography>
                                            <Typography fontWeight={500} fontSize={'16px'} color={'#6B6B6B'} sx={{
                                                paddingTop: '6px'
                                            }}>
                                                {t('t76')}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>

                        {/* page */}
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                            paddingTop: '30px',
                        }}>
                            <Pagination page={pageIndex} onChange={onChange} count={pageCount} variant="outlined" shape="rounded"></Pagination>
                        </Box>
                    </Box>
            }
        </Box>
    )
}

// ======================= EXPORT
export default SMNews
